"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.defaultProps = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash"));

var _classnames = _interopRequireDefault(require("classnames"));

var IconExports = _interopRequireWildcard(require("../../foundation/Icons"));

var _Tooltip = _interopRequireDefault(require("../Tooltip"));

var _ErrorText = _interopRequireDefault(require("./ErrorText"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var DropdownField = function DropdownField(props) {
  var id = props.id,
      name = props.name,
      children = props.children,
      label = props.label,
      labelPlacement = props.labelPlacement,
      classNames = props.classNames,
      disabled = props.disabled,
      defaultValue = props.defaultValue,
      onChange = props.onChange,
      value = props.value,
      closeOnItemSelect = props.closeOnItemSelect,
      placeholder = props.placeholder,
      tooltip = props.tooltip,
      tooltipIcon = props.tooltipIcon,
      hideError = props.hideError,
      errorText = props.errorText,
      rest = _objectWithoutProperties(props, ["id", "name", "children", "label", "labelPlacement", "classNames", "disabled", "defaultValue", "onChange", "value", "closeOnItemSelect", "placeholder", "tooltip", "tooltipIcon", "hideError", "errorText"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isExpanded = _useState2[0],
      setIsExpanded = _useState2[1];

  var _useState3 = (0, _react.useState)(defaultValue || ''),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedValue = _useState4[0],
      setSelectedValue = _useState4[1];

  (0, _react.useEffect)(function () {
    if (!_lodash.default.isUndefined(value)) setSelectedValue(value);
  }, [value]);

  var onButtonClick = function onButtonClick() {
    // if not disabled set if menu is expanded or not
    if (!disabled) setIsExpanded(!isExpanded);
  };

  var onSelect = function onSelect(itemValue) {
    // if developer doesnt control the displayed value, set it to the selected item
    if (_lodash.default.isUndefined(value)) {
      setSelectedValue(itemValue);
    }

    if (closeOnItemSelect) setIsExpanded(false); // if onChange is passed as a prop, call it

    if (onChange) onChange(itemValue);
  };

  var renderWrappedChildren = function renderWrappedChildren() {
    return _react.default.Children.map(children, function (child) {
      var itemOnClick = _lodash.default.get(child, ['props', 'onClick'], function () {});

      var itemValue = _lodash.default.get(child, ['props', 'value'], undefined); // If no value passed to menu item throw error


      if (_lodash.default.isUndefined(itemValue)) throw new Error('MenuItem used in DropdownField must include a value');

      var itemClassNames = _lodash.default.get(child, ['props', 'classNames', '']);

      var wrappedOnClick = function wrappedOnClick(e) {
        e.preventDefault();
        onSelect(itemValue);
        itemOnClick(e, itemValue);
      };

      var classToAdd = {
        'dropdown-group__control__menu__item': true,
        'dropdown-group__control__menu__item--selected': itemValue === selectedValue
      };
      return _react.default.cloneElement(child, {
        onClick: wrappedOnClick,
        classNames: (0, _classnames.default)(itemClassNames, classToAdd)
      });
    });
  };

  var getLabelFromValue = function getLabelFromValue(itemValue) {
    return _lodash.default.reduce(_react.default.Children.toArray(children), function (acc, child) {
      var childLabel = _lodash.default.get(child, ['props', 'label'], '');

      var childValue = _lodash.default.get(child, ['props', 'value'], '');

      if (childValue === itemValue) {
        return childLabel;
      }

      return acc;
    }, '');
  };

  var dropdownClassNames = {
    'dropdown-group__control': true,
    'dropdown-group__control--expanded': isExpanded,
    'dropdown-group__control--disabled': disabled
  };
  var inputIconClassNames = {
    'dropdown-group__control__input-container__icon': true,
    'dropdown-group__control__input-container__icon--expanded': isExpanded
  }; // ADA compliant - allow an enter key to act like a click.

  var _handleKeyPress = function _handleKeyPress(target) {
    if (target.key === 'Enter') {
      target.currentTarget.click();
    }
  };

  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: (0, _classnames.default)('dropdown-group', "dropdown-group--label-placement-".concat(labelPlacement))
  }, rest), label && /*#__PURE__*/_react.default.createElement("div", {
    className: "dropdown-group__label-container"
  }, /*#__PURE__*/_react.default.createElement("label", {
    id: "dropdown-group__".concat(id, "__label"),
    className: "dropdown-group__label",
    htmlFor: id
  }, label), tooltip && /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    classNames: "dropdown-group__tooltip",
    tooltipBody: tooltip
  }, // @ts-ignore
  _react.default.createElement(IconExports[tooltipIcon]))), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(dropdownClassNames, classNames),
    onKeyDown: _handleKeyPress,
    onClick: onButtonClick,
    role: "button",
    tabIndex: 0
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "dropdown-group__control__input-container"
  }, /*#__PURE__*/_react.default.createElement("input", {
    className: "dropdown-group__control__input-container__input",
    id: id,
    name: name,
    value: getLabelFromValue(selectedValue),
    type: "text",
    placeholder: placeholder,
    "aria-labelledby": label ? "dropdown-group__".concat(id, "__label") : id,
    readOnly: true,
    tabIndex: -1
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(inputIconClassNames)
  }, isExpanded ? /*#__PURE__*/_react.default.createElement(IconExports.IcoCaretDown, {
    flip: "vertical",
    title: "Close"
  }) : /*#__PURE__*/_react.default.createElement(IconExports.IcoCaretDown, {
    title: "Open"
  }))), isExpanded && /*#__PURE__*/_react.default.createElement("div", {
    className: "options dropdown-group__control__menu"
  }, renderWrappedChildren())), !hideError && /*#__PURE__*/_react.default.createElement("div", {
    className: "options dropdown-group__control__error_container"
  }, /*#__PURE__*/_react.default.createElement(_ErrorText.default, {
    classNames: "options dropdown-group__control__error_container__text"
  }, errorText)));
};

DropdownField.propTypes = {
  disabled: _propTypes.default.bool.isRequired,
  closeOnItemSelect: _propTypes.default.bool.isRequired,
  classNames: _propTypes.default.any.isRequired,
  labelPlacement: _propTypes.default.oneOf(['top', 'left']).isRequired,
  label: _propTypes.default.string,
  value: _propTypes.default.string,
  defaultValue: _propTypes.default.string,
  placeholder: _propTypes.default.string.isRequired,
  tooltipIcon: _propTypes.default.string,
  hideError: _propTypes.default.bool.isRequired,
  id: _propTypes.default.string.isRequired,
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.arrayOf(_propTypes.default.node)]).isRequired,
  onChange: _propTypes.default.func.isRequired,
  name: _propTypes.default.string,
  tooltip: _propTypes.default.string,
  errorText: _propTypes.default.string
};
var defaultProps = {
  classNames: '',
  closeOnItemSelect: true,
  disabled: false,
  labelPlacement: 'top',
  placeholder: 'Select',
  tooltipIcon: 'IcoInfoCircle',
  hideError: false
};
exports.defaultProps = defaultProps;
DropdownField.defaultProps = defaultProps;
var _default = DropdownField;
exports.default = _default;